import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Markup } from 'interweave';
import styled, { Box, css } from '@xstyled/styled-components';
import Button from '@/UI/Button';
import { useTranslation } from 'next-i18next';

const Tabs = styled.section`
  margin-bottom: 6rem;

  @media (max-width: desktop) {
    margin-bottom: 3.5rem;
    padding: 2rem 1rem 0;
  }
`;

const Tab = styled.div`
  padding-top: 2rem;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  p {
    max-width: 900px;
    line-height: 1.75;
  }

  ul {
    list-style-type: disc;

    @media (max-width: desktop) {
      padding-left: 1rem;
    }
  }

  ol {
    list-style-type: decimal;
  }

  a.brand_logo {
    @media (min-width: desktop) {
      display: none;
    }
  }
  a {
    text-decoration: underline;
    color: #54c8e6;
  }
`;

const TabButton = styled(Button)`
  position: relative;
  font-weight: 700;

  ${({ selected }) =>
    selected &&
    css`
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 2rem;
        width: 85px;
        height: 6px;
        background-color: teal-100;
      }
    `}
`;

export default function ProductTabs({ description, brand }) {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState(description ? 1 : 2);

  const transformDescription = node => {
    if (node.innerHTML === 'Üldinfo') return null;
    if (node.innerHTML === 'General information') return null;

  };

  const brandValues = brand?.value && brand?.image;

  return (
    <Tabs>
      {description && (
        <TabButton
          selected={selectedTab === 1}
          onClick={() => setSelectedTab(1)}
          p="0 4rem 0 0"
        >
          {t('product_main.general')}
        </TabButton>
      )}
      <TabButton
        selected={selectedTab === 2}
        onClick={() => setSelectedTab(2)}
        p="0"
      >
        {t('product_main.pay_installments')}
      </TabButton>
      {selectedTab === 1 && (
        <Tab>
          {brandValues && (
            <Link href={`/brands/${brand?.url_key}?id=${brand?.option_id}`}>
              <a className="brand_logo">
                <Image
                  src={brand?.image}
                  alt={brand?.value}
                  width={100}
                  height={100}
                  objectFit="contain"
                />
              </a>
            </Link>
          )}
          <Markup
            tagName="div"
            content={description}
            transform={transformDescription}
          />
        </Tab>
      )}
      {selectedTab === 2 && (
        <Tab>
          <Box mt={16} mb={16}>
            <h3> {t('product_main.ESTO_installments')}</h3>
            <Box spaceY={16}>
              <p>
                <strong>{t('product_main.pay_later')}:</strong> {t('product_main.buy_now')}
              </p>
              <p>
              <strong>{t('product_main.ESTO_3_TITLE')}:</strong> {t('product_main.ESTO_3')}
              </p>
              <p>
               <strong>{t('product_main.pay_installments')}:</strong> {t('product_main.installments_option_subtext')}

              </p>
            </Box>
          </Box>
          <h3>{t('product_main.liisi_installments')}</h3>
          <Box as="p" maxW={600}>
            {t('product_main.liisi_installments_subtext')}
          </Box>
          <Box as="p" mt={16}>
          {t('product_main.read_more')}:{' '}
            <Box
              as="a"
              fontWeight={700}
              href="https://holmbank.ee/jarelmaks"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('product_main.holmbank')}
            </Box>
          </Box>
        </Tab>
      )}
    </Tabs>
  );
}
